module.exports = __webpack_public_path__ + "img/f-thermometer-img3-2.80444c35.png";